module.exports = __webpack_public_path__ + "media/images/noimage-writer-241be5d616700d206169df54dedf939d.png";